import { useEffect, useState, useContext } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import styles from "./styles.module.css";
import AppBridgeHelper from "helpers/AppBridgeHelper";
import ShopContext from "context/ShopContext";

function SubMenuLayout({ menuItems }) {
  const { pathname } = useLocation();
  const [bridge, setBridge] = useState(null);
  const { hasKotValidity } = useContext(ShopContext);

  useEffect(() => {
    const load = async () => {
      try {
        const result = await AppBridgeHelper.getBridge();
        setBridge(result);
      } catch (e) {
        setBridge(null);
      }
    };
    load();
  }, []);

  const filteredMenuItems = menuItems.filter((item) => {
    if (item.id === "bluetooth_scale") {
      return bridge && bridge !== null;
    }
    if (item.id === "kotFormat" && !hasKotValidity) {
      return false;
    }
    return true;
  });

  return (
    <div className={styles.settingsWrapper}>
      <nav className={styles.subMenuBar}>
        {filteredMenuItems.map((item) => (
          <Link
            key={item.id}
            to={item.path}
            className={`${styles.subMenuItem} ${pathname.includes(item.path) ? styles.active : ""}`}
          >
            {item.name}
          </Link>
        ))}
      </nav>

      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
}

export default SubMenuLayout;
